import { EditorDialog } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { block } from '../utils';

export interface EditSceneModalControlPanelCardProps {
  children: React.ReactNode;
  className?: string;
}

const EditSceneModalControlPanelCard: React.FC<EditSceneModalControlPanelCardProps> = ({
  children,
  className,
}) => (
  <EditorDialog.ControlPaneSubheaderCard
    className={cn(block('card'), className)}
  >
    {children}
  </EditorDialog.ControlPaneSubheaderCard>
);

export default EditSceneModalControlPanelCard;
